var app_ampersand_table_setup = $('#app-ampersand-table-setup');

if (app_ampersand_table_setup.length) {
    function initializeAmpersandSetupTable() {
        window.app_ampersand_table_setup.DataTable({
            ajax: {
                url: '/ampersand/books/processing',
                dataSrc: 'data'
            },
            columns: [
                {data: 'book'},
                {data: 'filename'},
                {data: 'status'},
                {data: 'error'},
                {data: 'started_at'},
                {data: 'completed_at'},
            ],
            editable: false,
            destroy: true,
            pageLength: user_entries,
            lengthMenu: [
                [10, 25, 50, -1],
                [10, 25, 50, 'All'],
            ],
            "columnDefs": [
                {
                    "targets": 1,
                    "orderable": true,
                    "className": "text-center",
                    "createdCell": function (td, cellData, rowData, row, col) {
                        var html = cellData.toUpperCase();
                        $(td).html(html);
                    }
                },
                {
                    "targets": 2,
                    "orderable": true,
                    "className": "text-center",
                    "createdCell": function (td, cellData, rowData, row, col) {
                        var html = cellData.toUpperCase();
                        if(cellData === 'complete')
                            html = '<span style="color: green">'+html+'</span>'
                        else if(cellData === 'queue')
                            html = '<span style="color: orange">'+html+'</span>'
                        else if(cellData === 'processing')
                            html = '<span style="color: blue">'+html+'</span>'
                        else
                            html = '<span style="color: red">'+html+'</span>'
                        $(td).html(html);
                    }
                }
            ]
        });
    }

    initializeAmpersandSetupTable();

    // $('#select_all_books').on('click', function (e) {
    //     $('#app-comscore-table-setup  input:checkbox').each(function () {
    //         if ($(this).prop('disabled')=== false)
    //             $(this).prop('checked', true);
    //     });
    // });
    // $('#deselect_all_books').on('click', function (e) {
    //     $('#app-comscore-table-setup input:checkbox').prop('checked', false);
    // });

    $('#refresh_amp_table').on('click', function (e) {
        initializeAmpersandSetupTable();
    });

    // $('#activate_multiple_books').on('click', function (e) {
    //     var url = $(this).attr('data-url');
    //     var selectedItems = [];
    //     $('.books_check input[type=checkbox]').each(function () {
    //         if (this.checked) {
    //             selectedItems.push($(this).val());
    //         }
    //     });
    //     var ms = "Are you sure to activate these books?";
    //     if (selectedItems.length > 0){
    //         var r = confirm(ms);
    //         if(r){
    //             show_loader();
    //             var params = {
    //                 books: selectedItems,
    //             };
    //             $.ajax({
    //                 type: 'POST',
    //                 headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
    //                 data: JSON.stringify(params),
    //                 url: url,
    //                 dataType: "json",
    //                 contentType: "application/json",
    //                 success: function (response) {
    //                     global_notification('success', 'Books activated.');
    //                     initializeComscoreSetupTable();
    //                     hide_loader();
    //                 },
    //                 error: function (xhr) {
    //                     hide_loader();
    //                     ajax_error();
    //                     debug(xhr.responseText);
    //
    //                 }
    //             });
    //         }
    //     }
    //     else{
    //         alert('Please select at least one Book.');
    //     }
    // });
    //
    // $('#deactivate_multiple_books').on('click', function (e) {
    //     var url = $(this).attr('data-url');
    //     var selectedItems = [];
    //     $('.books_check input[type=checkbox]').each(function () {
    //         if (this.checked) {
    //             selectedItems.push($(this).val());
    //         }
    //     });
    //     var ms = "Are you sure to deactivate these books?";
    //     if (selectedItems.length > 0){
    //         var r = confirm(ms);
    //         if(r){
    //             show_loader();
    //             var params = {
    //                 books: selectedItems,
    //             };
    //             $.ajax({
    //                 type: 'POST',
    //                 headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
    //                 data: JSON.stringify(params),
    //                 url: url,
    //                 dataType: "json",
    //                 contentType: "application/json",
    //                 success: function (response) {
    //                     global_notification('success', 'Books deactivated.');
    //                     initializeComscoreSetupTable();
    //                     hide_loader();
    //                 },
    //                 error: function (xhr) {
    //                     hide_loader();
    //                     ajax_error();
    //                     debug(xhr.responseText);
    //
    //                 }
    //             });
    //         }
    //     }
    //     else{
    //         alert('Please select at least one Book.');
    //     }
    // });
}